import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Heading } from 'components';
import PercentLiner from 'bricks/PercentLiner';

import { mapResultsWithAnswers } from '../../helpers';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function ShowResultsViewLayout({
  totalRate,
  results,
  answers,
  className,
  isMobile,
  message,
  messageTagName,
}) {
  const mappedResults = mapResultsWithAnswers(totalRate, results, answers) || [];
  return (
    <div className={cx('wrapper', className, isMobile && 'mobile', 'column')}>
      <div className={cx('headingCell', isMobile && 'mobile', 'wrapperCell')}>
        {message ?
          <Heading
            tagName={messageTagName}
            level={isMobile ? 4 : 3}
            className={cx('heading', isMobile && 'mobile')}
          >
            {message}
          </Heading>
        : null}
      </div>
      <div className={cx('wrapperCell', 'contentCell', isMobile && 'mobile')}>
        <div className={cx('voteResults', isMobile && 'mobile')}>
          {mappedResults.map(({ percentRate, answerText, answerId }) => (
            <PercentLiner
              isMobile={isMobile}
              showPercent
              percentClassName={cx('percentCount', isMobile && 'mobile')}
              className={cx('result', isMobile && 'mobile')}
              percentage={percentRate}
              key={answerId}
            >
              <span className={cx('resultText', isMobile && 'mobile')}>{answerText}</span>
            </PercentLiner>
          ))}
        </div>
      </div>
    </div>
  );
}

ShowResultsViewLayout.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  message: PropTypes.string,
  messageTagName: PropTypes.string,
  totalRate: PropTypes.number,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.string,
      rate: PropTypes.number,
    }),
  ),
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.string,
      answerText: PropTypes.string,
    }),
  ),
};

ShowResultsViewLayout.defaultProps = {
  messageTagName: 'div',
};
